/**
 * @purpose sha1加密
 * @author zhangheng
 * @created 2018-05-10 10:09
 */

function Sha1Hex(sIn) {
  var _this = this;
  var x = _this.align(sIn);
  var w = new Array(80);
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;
  var e = -1009589776;
  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    var olde = e;
    for (var j = 0; j < 80; j++) {
      if (j < 16) w[j] = x[i + j];
      else w[j] = _this.rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
      var t = _this.add(
        _this.add(_this.rol(a, 5), _this.ft(j, b, c, d)),
        _this.add(_this.add(e, w[j]), _this.kt(j))
      );
      e = d;
      d = c;
      c = _this.rol(b, 30);
      b = a;
      a = t;
    }
    a = _this.add(a, olda);
    b = _this.add(b, oldb);
    c = _this.add(c, oldc);
    d = _this.add(d, oldd);
    e = _this.add(e, olde);
  }
  _this.sha1Value =
    _this.hex(a) + _this.hex(b) + _this.hex(c) + _this.hex(d) + _this.hex(e);
  //return SHA1Value/*.toUpperCase()*/;
}

Sha1Hex.prototype.add = function(x, y) {
  return (
    ((x & 0x7fffffff) + (y & 0x7fffffff)) ^ (x & 0x80000000) ^ (y & 0x80000000)
  );
};

Sha1Hex.prototype.hex = function(num) {
  var sHEXChars = "0123456789abcdef";
  var str = "";
  for (var j = 7; j >= 0; j--) str += sHEXChars.charAt((num >> (j * 4)) & 0x0f);
  return str;
};

Sha1Hex.prototype.align = function(sIn) {
  var nblk = ((sIn.length + 8) >> 6) + 1,
    blks = new Array(nblk * 16);
  for (var i = 0; i < nblk * 16; i++) blks[i] = 0;
  for (i = 0; i < sIn.length; i++)
    blks[i >> 2] |= sIn.charCodeAt(i) << (24 - (i & 3) * 8);
  blks[i >> 2] |= 0x80 << (24 - (i & 3) * 8);
  blks[nblk * 16 - 1] = sIn.length * 8;
  return blks;
};

Sha1Hex.prototype.rol = function(num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt));
};

Sha1Hex.prototype.ft = function(t, b, c, d) {
  if (t < 20) return (b & c) | (~b & d);
  if (t < 40) return b ^ c ^ d;
  if (t < 60) return (b & c) | (b & d) | (c & d);
  return b ^ c ^ d;
};

Sha1Hex.prototype.kt = function(t) {
  return t < 20
    ? 1518500249
    : t < 40
    ? 1859775393
    : t < 60
    ? -1894007588
    : -899497514;
};

function sha1(sIn) {
  var hex = new Sha1Hex(sIn);
  return hex.sha1Value;
}
module.exports = {
  sha1: sha1
};
